import ChemComponent from '../ChemComponent';
import { Col, Container, Row, Button } from 'react-bootstrap';

class Process extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			stdout: '',
			stderr: '',
			cmd: 'c:\\inetpub\\wwwroot\\chemnet\\selenium-manager\\windows\\selenium-manager.exe',
			args: ['--browser chrome'],
			renderKey: 0
		}
	}

	onSubmit(event) {
		var self = this;

		this.ajax({
			type: 'POST',
			url: this.getConfig().host + '/Admin/RunProcess',
			data: {
				cmd: this.state.cmd,
				args: this.state.args
			}
		}).done(function (data) {
			if (data.Success) {
				self.mergeState({
					stdout: data.StandardOutput,
					stderr: data.StandardError
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	render() {
		var cmd = this.state.cmd;
		for (var i = 0; i < this.state.args.length; i++) {
			cmd += ' ' + this.state.args[i];
		}
		return (<>
			<Container fluid>
			  <Row>
			    <Col md={12} lg={11} xl={10} style={{ paddingTop: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Command</span><br />
				  <br />
				  {cmd}<br />
				  <br />
				  <Button id="save" variant="warning" type="button" onClick={(event) => this.onSubmit(event)} disabled="disabled">Run</Button>
				</Col>
			  </Row>
			  <Row>
			    <Col md={12} lg={11} xl={10} style={{ paddingTop: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Standard Output</span><br />
				  <br />
				  {this.state.stdout}
				</Col>
			  </Row>
			  <Row>
			    <Col md={12} lg={11} xl={10} style={{ paddingTop: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Standard Error</span><br />
				  <br />
				  {this.state.stderr}
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

export default Process;
